/* eslint-disable no-undef */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import WaveSurfer from 'wavesurfer.js';
import MicPlugin from 'wavesurfer.js/dist/plugin/wavesurfer.microphone';
import Waveform from '../components/waveform';
import { tspan } from '../utils/i18n';
import { ColoredFooter } from './mic-check';
import {faStop} from "@fortawesome/pro-solid-svg-icons";
import SendVox from "../components/buttons/send";
import isMobile from '../utils/mobilecheck';
import {Get_Recorder_Tags} from "../utils/graph-api";
import {withApollo} from "react-apollo";
import {ToolTip, ToolTipText} from "../styles/styled/toolTip";
import {faIcons} from  '../new-icons/fa-icons';
import ga from '../utils/ga-tracker';
import { stopRecButton } from '../utils/alt-tags';



const RecordingContainer = styled.div`
    flex: 1;

    display: flex;
    flex-direction: column; 

    .content {
        flex: 5;

        .countdown-timer {
            margin-top: 5rem !important;
            margin: auto;
            font-size: 4rem;
            color: #ccc;
            font-weight: 900;
        }
    }

    .buttons {
        ${props => props.pluginMode && css`
            span {
                min-height: 2.5rem;
                color: firebrick;
            }
        `}
    }
`;

export const BottomText = styled.p`
    z-index: 2;
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 14px;
    color: #858C9A;
`;

const ChannelTypeIcon = styled(ToolTip)`
  &:hover {
      cursor: ${(props) => (props.showToolTip === '' ? 'default' : 'pointer')};
  }
  &:hover .tooltiptext {
        visibility:${(props) => (props.showToolTip === '' ? 'hidden' : 'visible')};
       
  }

`;

const ChannelToolTip = styled(ToolTipText)`
  height: 1.5rem !important;  
  width: 172px !important;
  bottom: 91% !important;
  left: -87px !important;
  padding: 3px 0px 2px 0px !important;
  text-transform: capitalize !important;
  font-style: normal;
  font-family: Titillium Web;
  z-index: 9;
  visibility: visible;
`;

const defaultState = {
    // Countdown
    countdown: 0,
    countdownTimer: null,
    // The recorder instance used
    recorder: null,
    // The wavesurfer instance used
    wavesurfer: null,
    // Is the recording in progress
    recording: false,
    progress: 0,
    processing: true,
    minRecLengthText: true,
    tagOptions: null,
    hideToolTip: true,
    bufferDuration: 0,
};

var gumStream;
var recorder;
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
let rec; let wave; let
  recBlob;
// We are commented for the time being, Maybe we will use in future.
// const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
// let context; let processor;

class Recording extends Component {
    static propTypes = {
        showPopup: PropTypes.func
    };

    state = {
        ...defaultState
    };

     componentDidMount() {
        const { countdown, isPublicHosted } = this.props;

        if (countdown) {
            // Do a countdown before starting
            this.setState({ countdown, countdownTimer: setInterval(this.doCountDown.bind(this), 1000) });
        } else {
            // Immediately start recording
            this.beginRecording();
            this.changeMinRecordingText();
        }
        this.toggleLoader();
        if (isPublicHosted) {
            this.getTagOptions();
        }
        window.addEventListener('message', this.receiveMessage, false);
    }

    receiveMessage = (event) => {
      if (event.data === 'ClosePluginEvent' && rec) {
        this.stopRecording();
      }
    };

    componentWillUnmount() {
        window.removeEventListener('message', this.receiveMessage, false);
    }

    doCountDown() {
        const { countdown, countdownTimer } = this.state;

        if (countdown <= 0) {
            // Countdown complete
            clearInterval(countdownTimer);
            this.setState({ countdownTimer: null, countdown: 0 });

            // Start
            this.changeMinRecordingText();
        } else {
            this.setState({ countdown: countdown - 1 });
            if(countdown - 1 === 0){
              this.beginRecording();
            }
        }
    }

    changeMinRecordingText() {
         setTimeout( () => {
            this.setState( prevState => ({
                minRecLengthText: false
            }));
        }, 3000);
    }
    beginRecording() {
        const { settings: { common, recorder: recorderSettings } } = this.props;
        const { timeoutController: oldTimeout } = this.state;
        if (oldTimeout) clearTimeout(oldTimeout);
        const encodingType = 'mp3';
        rec = null;
        wave = null;
        recBlob = null;
        const that = this;
        const newRec = Recorder({
          type: encodingType,
          sampleRate: 48000,
          bitRate: 96,
          onProcess(buffers, powerLevel, bufferDuration, bufferSampleRate, newBufferIdx, asyncEnd) {
            wave.input(buffers[buffers.length - 1], powerLevel, bufferSampleRate);
            that.setState({
              bufferDuration: bufferDuration,
            })
          },
        });
        newRec.open(() => {
          rec = newRec;
          recBlob = null;
          rec.start();
          wave = Recorder.FrequencyHistogramView({
            elem: '.recwave',
            lineCount: 90,
            position: 0,
            minHeight: 1,
            linear: [0, common.waveformColor, 0.1, common.waveformColor, 1, common.buttonColor],
            stripeEnable: false,
          });
          this.setState({
            recorder: rec,
            recording: true,
            timeoutController: setInterval(() => this.iterateProgressBar(1000), 1000),
          });
        }, (msg, isUserNotAllow) => {
          console.log(`${isUserNotAllow ? 'UserNotAllow，' : ''}Failed to open recording：${msg}`, 1);
        });
    }
    async getTagOptions ()  {
        const channelToken = window.location.href.split("/")[3];
        const { client } = this.props;
        const { data } = await client.query({
            query: Get_Recorder_Tags,
            variables: { channelToken: channelToken},
            fetchPolicy: 'no-cache'
        });
        this.setState({tagOptions: data.getRecorderTags},
            () =>    {
                this.state.tagOptions.map((item,index)=>{
                    item.fontAwesomeIcon = faIcons[item.fontAwesomeIcon]
                } )
            }
        )

    }
    hideTooltip() {
        setTimeout( () => {
            this.setState( prevState => ({
                hideToolTip: true
            }));
        }, 1000);
    }


    stopRecording() {
        const { onSwitch, settings: { recorder: recorderSettings } } = this.props;
        const { timeoutController, wavesurfer, processing , tagOptions, progress, bufferDuration} = this.state;
        const { common } = this.props.settings;

        // If any timeout was running, clear it
        if (timeoutController) clearInterval(timeoutController);
        if ((bufferDuration / 1000) > 5 || !common.isPublicHosted) {
            this.setState({ processing: true, hideToolTip: true });
            if (rec) {
              if (!(rec && Recorder.IsOpen())) {
                console.log('Recording is not turned on', 1);
                return;
              }
              rec.stop((blob, duration) => {
                recBlob = blob;
                const url = URL.createObjectURL(blob);
                rec.close();
                rec = null;
                if (ga.initialized) {
                  ga.f.event({
                    category: 'recording',
                    action: 'stop',
                    value: progress
                  })
                }
                common.isContactSkip ?
                onSwitch('send-vox', {blob: blob, url})
                :
                onSwitch('playback', {blob: blob, url, tagOptions})
              }, (msg) => {
                rec.close();
                rec = null;
                console.log(`Recording failed:${msg}`, 1);
              });
            }
        } else {
            this.setState({
                hideToolTip: false
            });
            this.hideTooltip();
        }
    }

    iterateProgressBar(interval) {
        const { settings: { common } } = this.props;
        let { progress } = this.state;

        // Seconds to MS
        const msTimeLimit = common.recordingTimeLimit * 1000;

        // Progress is a %age,
        // Convert it to a MS value
        progress *= msTimeLimit;

        // Next, add the MS interval
        progress += interval;

        // If we're at, or slightly beyond the limit, stop and clamp progress
        if (progress >= msTimeLimit) {
            this.setState({ progress: 1 });
            this.stopRecording();
        } else {
            this.setState({ progress: progress / msTimeLimit });
        }
    }

    toggleLoader = () => {
       this.setState({ processing: false })
    };

    render() {
        const { pluginMode, settings: { common } } = this.props;
        const { recording, progress, countdown, minRecLengthText, hideToolTip} = this.state;

      return (
        <RecordingContainer pluginMode={pluginMode}>
          <div className="content">
            {/* Title for the recording page */}
              <div className="plugin-header">
              <div
              className="title"
              style={{
                  fontStyle: 'normal',
                  fontFamily: 'Titillium Web',
                  fontWeight: 'bold',
                  fontSize: '16px',
                  lineHeight: '24px',
                  color:'#27364E',
                  wordBreak:'break-word',
                  whiteSpace: 'pre-wrap',
              }}

            >
             {recording ? tspan('recordTitle') : null}
                {countdown > 0 ? tspan('recording-starting') : null}
            </div>
            </div>

            {/* Subtitle */}
              <div
                className="sub-title"
                style={{
                    fontStyle: 'normal',
                    fontFamily: 'Titillium Web',
                    fontWeight: 'normal',
                    fontSize: '15px',
                    lineHeight: '23px',
                    color:'#27364E',
                    marginTop:`${pluginMode ? "10px" : "0"}`,
                    wordBreak:'break-word',
                    whiteSpace: 'pre-wrap',
                }}
              >
                {recording && tspan('recordSubTitle')}
              </div>

            <div className="content-footer" style={{paddingBottom: '0.5rem'}}>
              {/* Waveform, and properties */}
              {countdown <= 0 ? (
                <Waveform
                  progressBarPrimaryColor={common.buttonColor}
                  progressBarSecondaryColor={common.waveformColor}
                  maximumSecondsLength={common.recordMaxLength}
                  isPublicHosted={common.isPublicHosted}
                  hidden={!recording}
                  details={!!recording}
                  progress={progress}
                  pluginMode={pluginMode}
                  toggleLoader={this.toggleLoader}
                  recordingScreen
                  sourceType="Recording"
                />
              ) : (
                <div className="countdown-timer">
                  {countdown}
                </div>
              )}
            </div>
          </div>

          {/* Buttons */}
            {countdown <= 0 && (
          <BottomText>{(minRecLengthText && common.isPublicHosted) ?
              ("Please record at least 5 seconds") : ("Press to stop recording")}</BottomText>
            )}
          <ColoredFooter className="buttons" requiredShadow={common.requiredShadow} hideGreyBar={common.hideGreyBar}>
              {countdown <= 0 ? (!hideToolTip && common.isPublicHosted) ?
                  (<ChannelTypeIcon>
                          <ChannelToolTip className="tooltiptext">{"just a few more seconds to go!"}</ChannelToolTip>
                          <SendVox common={common} arrow={false} processing={this.state.processing}
                                   onClick={() => this.stopRecording()}
                                   icon={faStop} micPermission={true}/>
                  </ChannelTypeIcon>) :
                  (<SendVox common={common} arrow={false} processing={this.state.processing}
                           onClick={() => this.stopRecording()} icon={faStop} micPermission={true}
                            title={stopRecButton}
                  />)
                  : null}

          </ColoredFooter>
        </RecordingContainer>
      );
    }
}
export default withApollo(Recording);
